import { FC } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import { Box, Grid, Stack, Typography } from '@mui/material';

// third-party
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// project-imports
import MainCard from 'components/MainCard';
import { RootState } from '../../store';

// assets
import { Calendar } from 'iconsax-react';

// ==============================|| DASHBOARD - WELCOME BANNER ||============================== //

const WelcomeBanner: FC = () => {
  const { t } = useTranslation();
  const username = useSelector((state: RootState) => state.login.user?.username);

  return (
    <MainCard
      border={false}
      sx={(theme: Theme) => ({
        color: theme.palette.common.white,
        background:
          theme.palette.mode === 'dark'
            ? `linear-gradient(135deg, ${theme.palette.primary.darker} 0%, ${theme.palette.primary.dark} 100%)`
            : `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
        overflow: 'hidden',
        // decorative concentric rings on the right
        '&:after': {
          content: '""',
          position: 'absolute',
          width: 260,
          height: 260,
          borderRadius: '50%',
          top: -90,
          right: -60,
          background: 'rgba(255,255,255,0.08)',
        },
        '&:before': {
          content: '""',
          position: 'absolute',
          width: 180,
          height: 180,
          borderRadius: '50%',
          bottom: -80,
          right: 80,
          background: 'rgba(255,255,255,0.06)',
        },
      })}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ position: 'relative', zIndex: 1 }}
      >
        <Grid item xs={12} sm={8}>
          <Stack spacing={1} sx={{ p: { xs: 1, sm: 2 } }}>
            <Typography variant="h3" color="inherit">
              {username
                ? t('dashboard.welcome.title', { name: username })
                : t('dashboard.welcome.title_generic')}
            </Typography>
            <Typography
              variant="h6"
              color="inherit"
              sx={{ opacity: 0.85, fontWeight: 400, maxWidth: 520 }}
            >
              {t('dashboard.welcome.subtitle')}
            </Typography>
          </Stack>
        </Grid>
        <Grid item sx={{ display: { xs: 'none', sm: 'flex' }, pr: { sm: 4, md: 8 }, zIndex: 1 }}>
          <Box
            sx={{
              width: 84,
              height: 84,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(255,255,255,0.15)',
              '& svg': { width: 40, height: 40 },
            }}
          >
            <Calendar variant="Bold" />
          </Box>
        </Grid>
      </Grid>
    </MainCard>
  );
};

export default WelcomeBanner;
